import React, { Fragment } from "react";
import AdvancedManagementCardWithInput from "./AdvancedManagementCardWithInput";
import UploadFile from "../../../../shared/UploadFile/UploadFile";
import { CSSTransition } from "react-transition-group";
import Card from "../../../../shared/Card/Card";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

const AdvancedManagementScannedStatement = ({ onSave, onCancel, onChange, documents } = props) => {
	return (
		<>
			<Card className="advanced-management-send-documents__card" withoutMargin>
				<h4>Envio de declaração digitalizada</h4>
				<p>
					Você deverá anexar aqui a declaração assinada de comprovação de vínculo com o
					participante. O documento será enviado automaticamente para análise da MaxMilhas.
				</p>
				<div className="advanced-management-send-documents__card__uploads-files">
					<div className="advanced-management-send-documents__card__uploads-files--line">
						<div className="advanced-management-send-documents__card__uploads-files--line--upload">
							<UploadFile
								label={<strong>Declaração de Vínculo assinada</strong>}
								onChange={event => onChange("declaration", event)}
								accept="image/png,image/jpeg"
							/>
						</div>
						<div className="advanced-management-send-documents__card__uploads-files--line--text-lastDocuments">
							<p>
								Atenção! A assinatura da declaração precisa ser exatamente igual a do documento
								enviado por você.
							</p>
						</div>
					</div>
				</div>
			</Card>
			<div className="advanced-management-send-documents__actions">
				<Button onClick={() => onCancel()} className="btn-gray-lg-label btn--without-bold">
					Cancelar
				</Button>
				<Button
					disabled={!documents.declaration || !documents.declarationFile}
					onClick={() => {
						onSave();
						publish(eventType.ACCOUNT_FAMILY, {
							type: ACCOUNT_FAMILY_EVENT.button_approve_part_manager
						})
					}}
					className="btn-primary-lg"
				>
					Avançar
				</Button>
			</div>
		</>
	);
};

export default AdvancedManagementScannedStatement;
